import React, { FC, memo, useState } from 'react'
import { Text } from '@/client/components'
import * as S from './styles'
import { TextProps } from './types'

export const FormCol: FC<TextProps> = memo(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ header, description, noContent = false, optionalField, children, ...rest }) => {
    const [showContent, setShowContent] = useState(true)
    const toggleContent = () => {
      setShowContent(!showContent)
    }
    return (
      <S.FormWrap>
        <S.ContentPart className='form-col-content-part'>
          <S.ContentWrap>
            <S.ContentHeader onClick={toggleContent}>
              <Text size='lg' margin='0 0 0 0'>
                {!noContent && header}
                {!noContent && !optionalField && <S.ReqText>*</S.ReqText>}
              </Text>
            </S.ContentHeader>
            {/* <S.ContentDescription>
              <Text size='xs' italic margin='0'>
                {description}
              </Text>
            </S.ContentDescription> */}
          </S.ContentWrap>
        </S.ContentPart>
        <S.InputPart inline className='input-part-set'>
          {children}
        </S.InputPart>
      </S.FormWrap>
    )
  }
)

FormCol.displayName = 'FormCol'
